// Copyright 2026. WebPros International GmbH. All rights reserved.

import { IGpuResponse } from 'common/api/resources/Gpu';
import {
    FC,
    memo,
} from 'react';
import {
    Action,
    Alert,
    List,
    Translate,
} from '@plesk/ui-library';
import { pathTo } from 'common/helpers/core';
import CopyText from 'common/containers/CopyText/CopyText';
import { VmStatus } from 'common/components/VmStatus';

interface IProps {
    gpu: IGpuResponse;
}

const COLUMNS = [
    {
        key: 'colServer',
        title: <Translate content="computeResource.vgpu.attachment.virtualServer" />,
    },
    {
        key: 'colUuid',
        title: <Translate content="computeResource.vgpu.attachment.uuid" />,
    },
    {
        key: 'colStatus',
        title: <Translate content="computeResource.vgpu.attachment.status" />,
    },
];

const GpuPassthroughAttachment: FC<IProps> = ({ gpu }) => {
    const server = gpu.passthrough_attachment?.server;

    const data = server ? [{
        id: server.id,
        colServer: (
            <Action
                href={pathTo(`servers/${server.id}`)}
                target="_blank"
            >
                {server.name}
            </Action>
        ),
        colUuid: server.uuid ? <CopyText>{server.uuid}</CopyText> : null,
        colStatus: server.status ? <VmStatus status={server.status} isProcessing={false} /> : null,
    }] : [];

    return (
        <List
            columns={COLUMNS}
            data={data}
            rowKey={'id'}
            emptyView={
                <Alert><Translate content="computeResource.vgpu.notAttached" /></Alert>
            }
        />
    );
};

export default memo(GpuPassthroughAttachment);
